import React, { useEffect, useRef, useState } from 'react';
import { Button, Tip } from 'grommet';
import { Copy } from 'grommet-icons';
import PropTypes from 'prop-types';

// Small icon button that copies `value` to the clipboard and briefly swaps its
// tooltip to "Copied!". Renders nothing when there is no value to copy.
export const CopyButton = ({
    value,
    a11yTitle = 'Copy to clipboard',
    confirmationMs = 2000,
}) => {
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(
        () => () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        },
        [],
    );

    if (!value) {
        return null;
    }

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            timeoutRef.current = setTimeout(
                () => setCopied(false),
                confirmationMs,
            );
        } catch (error) {
            console.log(error);
        }
    };

    const label = copied ? 'Copied!' : a11yTitle;

    return (
        <Tip content={label}>
            <Button
                plain
                a11yTitle={label}
                icon={<Copy size="small" />}
                onClick={handleCopy}
            />
        </Tip>
    );
};

CopyButton.propTypes = {
    value: PropTypes.string,
    a11yTitle: PropTypes.string,
    confirmationMs: PropTypes.number,
};
